import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { ThemeType } from "@ant-design/icons-angular";
import { TooltipPosition } from "@webapp/ui/tooltip/tooltip.models";

/**
 * This component extends the base Icon directive of NG-Zorro
 * Example usage : https://ng.ant.design/components/icon/en
 */

@Component({
  selector: "ui-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["icon.component.less"],
})
export class UiIconComponent implements OnInit {
  @Input()
  public iconClass: string;

  @Input()
  public legacyIconSrc: string;

  @Input()
  iconSpin: boolean;

  @Input()
  iconType: string;

  @Input()
  iconTheme: ThemeType;

  @Input()
  iconTwotoneColor: string;

  @Input()
  iconIconfont: string;

  @Input()
  iconRotate: number;

  @Input()
  tooltipAppendToBody = false;

  @Input()
  showTooltip = false;

  @Input()
  tooltipContent: string;

  @Input()
  tooltipPosition: TooltipPosition = "top";

  @Input()
  tooltipContainer?: string | ElementRef;

  get isLegacyIcon() {
    return this.iconClass && this.iconClass.indexOf("nc-icon") > -1;
  }

  ngOnInit(): void {
    if (this.tooltipContent) {
      this.showTooltip = true;
    }
  }
}
